<template>
  <!-- Barra de Navegacion -->
  <nav class="navbar">
    <div class="brand-title">
      <img src="@/assets/images/funifelt.png"> 
      <router-link to="/iniciales">
        <h3 v-if="language.includes('es')">Español Básico</h3>
        <h3 v-else>Elementary Spanish</h3>
      </router-link>
    </div>
    <a :style="[isLoggedIn ? '' : { 'display': 'none' }]" href="#" class="toggle-button">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </a>

    <div class="navbar-links">
      <ul v-if="language.includes('es')">
        <li> <router-link to="/iniciales" v-if="isLoggedIn" :style="[$route.name === 'unidades' ? { 'background-color': '#3B5CAB' } : '']" > Unidades </router-link> </li>
        <li> <router-link to="/perfil" v-if="isLoggedIn" :style="[$route.name === 'perfil' ? { 'background-color': '#3B5CAB' } : '']" > Perfil </router-link> </li>
      </ul>
      <ul v-else>
        <li> <router-link to="/iniciales" v-if="isLoggedIn" :style="[$route.name === 'unidades' ? { 'background-color': '#3B5CAB' } : '']" > Units </router-link> </li>
        <li> <router-link to="/perfil" v-if="isLoggedIn" :style="[$route.name === 'perfil' ? { 'background-color': '#3B5CAB' } : '']" > Profile </router-link> </li>
      </ul>
    </div>
  </nav>

  <div id="page-container">
    <!-- Contenido de la vista/componente -->
    <div id="content-wrap">
      <router-view/>
    </div>
    <!-- Footer -->
    <footer v-if="language.includes('es')" id="footer">
      <div class="footer-container">

          <div class="categories">
            <h2 @click="showCategory(0)">
              Visítanos 
              <i v-if="isMobile && !isOpen1" class="material-icons">&#xe5c5;</i> 
              <i v-else-if="isMobile && isOpen1" class="material-icons">&#xe5c7;</i>
            </h2>
            <div class="category-options">
              <ul>
                <li> <a href="https://www.funifelt.com/" target="_blank"> FUNIFELT Sitio Web </a> </li>
                <li> <a href="https://relatos-mitos-y-leyendas.web.app/" target="_blank"> Relatos Culturales </a> </li>
                <li> <a href="https://funifelt--ovas.web.app/" target="_blank"> Conociendo Colombia </a> </li>
                <li> <a href="https://play.google.com/store/apps/dev?id=5041211756149277759" target="_blank"> Apps de Idiomas </a> </li>
                <li> <a href="https://jergacolombianafunifelt.web.app/" target="_blank"> Jergas Latinoamericanas </a> </li>
                <li> <a href="https://spanish-ova-funifelt.web.app/" target="_blank"> Introducción al Español </a> </li>
                <li> <a href="https://unity--language-game-funifelt.web.app/" target="_blank"> Juegos Online </a> </li>
                <li> <a href="https://viva-la-ciencia.web.app/" target="_blank"> Hurra! Me gustan las Ciencias </a> </li>
              </ul>
            </div>
          </div>

          <div class="categories" >
            <h2 @click="showCategory(1)">
              Sobre Nosotros
              <i v-if="isMobile && !isOpen2" class="material-icons">&#xe5c5;</i> 
              <i v-else-if="isMobile && isOpen2" class="material-icons">&#xe5c7;</i>
            </h2>
            <div class="category-options">
              <ul>
                <li> <router-link to="/advisors">Asesores</router-link> </li>
                <li> <router-link to="/research">Investigación</router-link> </li>
                <li> <router-link to="/contact">Contacto</router-link> </li>
                <li> <router-link to="/help">Ayuda</router-link> </li>
              </ul>
            </div>
          </div>

      </div>

      <div class="social-links">
        <a href="https://www.facebook.com/funifelt/" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-facebook.png?alt=media&token=141a1cab-5c53-4a78-af88-76acc3761569"> </a>
        <a href="https://twitter.com/funifelt/" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-twitter.png?alt=media&token=40f07170-a904-450f-a409-af3b5443db6e"> </a>
        <a href="https://www.youtube.com/channel/UCbz3YP4xOUUnGRQgQlhsEsQ" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-youtube.png?alt=media&token=46af4c2c-933c-4588-b623-d365c68eeffc"> </a>
        <a href="https://www.instagram.com/funifelt/" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-instagram.png?alt=media&token=38dacecd-7b81-4027-859c-0abe4d417c0b"> </a>
        <a href="https://www.linkedin.com/company/funifelt" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-linkedin.png?alt=media&token=944dc1ae-c14c-4131-8287-a771193ab86c"> </a>
        <a href="https://open.spotify.com/show/4uu0KBkcsE1p9l9TH0eHBv" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-spotify.png?alt=media&token=4821f5f8-ecc8-49b4-a151-c524e6a0f1f8"> </a>
        <a href="https://www.threads.net/@funifelt" target="_blank"> <img src="https://static.wixstatic.com/media/11062b_de6ea2753cd641be9085a85b55be7882~mv2.png/v1/fill/w_39,h_39,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_de6ea2753cd641be9085a85b55be7882~mv2.png"> </a>
        <a><img @click="shareApp" class="shareButton" src="https://firebasestorage.googleapis.com/v0/b/spanish-ova-funifelt.appspot.com/o/Share%20white.png?alt=media&token=9fe061a2-d3c5-4969-a042-5ba98b19ddd2"></a>
      </div>
      <div class="rights">
        &copy; FUNIFELT 2023 - Todos los derechos reservados
      </div>
    </footer>

    <footer v-else id="footer">
      <div class="footer-container">

          <div class="categories" >
            <h2 @click="showCategory(0)">
              Visit Us
              <i v-if="isMobile && !isOpen1" class="material-icons">&#xe5c5;</i> 
              <i v-else-if="isMobile && isOpen1" class="material-icons">&#xe5c7;</i>
            </h2>
            <div class="category-options">
              <ul>
                <li> <a href="https://www.funifelt.com/" target="_blank"> FUNIFELT Website </a> </li>
                <li> <a href="https://relatos-mitos-y-leyendas.web.app/" target="_blank"> Spanish Folktales </a> </li>
                <li> <a href="https://funifelt--ovas.web.app/" target="_blank"> Learning About Colombia </a> </li>
                <li> <a href="https://play.google.com/store/apps/dev?id=5041211756149277759" target="_blank"> Language Apps </a> </li>
                <li> <a href="https://jergacolombianafunifelt.web.app/" target="_blank"> Spanish Slang Words </a> </li>
                <li> <a href="https://spanish-ova-funifelt.web.app/" target="_blank"> Spanish for Beginners </a> </li>
                <li> <a href="https://unity--language-game-funifelt.web.app/" target="_blank"> Language Games </a> </li>
                <li> <a href="https://viva-la-ciencia.web.app/" target="_blank"> Hooray! I Love Science </a> </li>
              </ul>
            </div>
          </div>

          <div class="categories" >
            <h2 @click="showCategory(1)">
              About Us
              <i v-if="isMobile && !isOpen2" class="material-icons">&#xe5c5;</i> 
              <i v-else-if="isMobile && isOpen2" class="material-icons">&#xe5c7;</i>
            </h2>
            <div class="category-options">
              <ul>
                <li> <router-link to="/advisors">Advisors</router-link> </li>
                <li> <router-link to="/research">Research</router-link> </li>
                <li> <router-link to="/contact">Contact Us</router-link> </li>
                <li> <router-link to="/help">Help</router-link> </li>
              </ul>
            </div>
          </div>

      </div>

      <div class="social-links">
        <a href="https://www.facebook.com/funifelt/" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-facebook.png?alt=media&token=141a1cab-5c53-4a78-af88-76acc3761569"> </a>
        <a href="https://twitter.com/funifelt/" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-twitter.png?alt=media&token=40f07170-a904-450f-a409-af3b5443db6e"> </a>
        <a href="https://www.youtube.com/channel/UCbz3YP4xOUUnGRQgQlhsEsQ" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-youtube.png?alt=media&token=46af4c2c-933c-4588-b623-d365c68eeffc"> </a>
        <a href="https://www.instagram.com/funifelt/" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-instagram.png?alt=media&token=38dacecd-7b81-4027-859c-0abe4d417c0b"> </a>
        <a href="https://www.linkedin.com/company/funifelt" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-linkedin.png?alt=media&token=944dc1ae-c14c-4131-8287-a771193ab86c"> </a>
        <a href="https://open.spotify.com/show/4uu0KBkcsE1p9l9TH0eHBv" target="_blank"> <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ficono-spotify.png?alt=media&token=4821f5f8-ecc8-49b4-a151-c524e6a0f1f8"> </a>
        <a href="https://www.threads.net/@funifelt" target="_blank"> <img src="https://static.wixstatic.com/media/11062b_de6ea2753cd641be9085a85b55be7882~mv2.png/v1/fill/w_39,h_39,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_de6ea2753cd641be9085a85b55be7882~mv2.png"> </a>
        <a><img @click="shareApp" class="shareButton" src="https://firebasestorage.googleapis.com/v0/b/spanish-ova-funifelt.appspot.com/o/Share%20white.png?alt=media&token=9fe061a2-d3c5-4969-a042-5ba98b19ddd2"></a>
      </div>
      <div class="rights">
        &copy; FUNIFELT 2023 - All rights reserved
      </div>
    </footer>

    <!-- Notificacion de que se utilizan cookies -->
    <Cookies v-if="ToggleCookies" v-on:aceptado="cerrarCookies"/>

  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import Cookies from '@/components/cookies.vue'

export default {
  components: {
    Cookies
  },
  setup() {
    const isLoggedIn = ref(false)
    let auth
    onMounted(() => {
      // Funcion para conocer si el usuario esta autenticado
      auth = getAuth()
      onAuthStateChanged(auth, (user) => {
        if (user) {
          isLoggedIn.value = true
        } else {
          isLoggedIn.value = false
        }
      })

      // Barra de navegacion
      const toggle_button = document.getElementsByClassName("toggle-button")[0]
      const navbar_links = document.getElementsByClassName("navbar-links")[0]
      
      // Funcion para minimizar la barra de navegacion luego de hacer click en alguna opcion (resoluciones menores a 1000px)
      navbar_links.querySelectorAll('li').forEach((link) => { 
        link.addEventListener("click", () => {
          navbar_links.classList.toggle("active")
        })
      })
      // Funcion para plegar/desplegar la barra de navegacion luego de hacer click en el icono (resoluciones menores a 1000px)
      toggle_button.addEventListener("click", () => {
        navbar_links.classList.toggle("active")
      })
    })

    return {
      isLoggedIn
    }
  },
  data () {
    return {
      language: navigator.language,
      isMobile: window.innerWidth < 1000,
      isOpen1: false,
      isOpen2: false,

      // Notificacion de uso de cookies
      ToggleCookies: false,
      notificacionCookies: localStorage.getItem('notificacionCookies')
    }
  },
  mounted () {
    // Mostrar notificacion de uso de cookies si el usuario no la ha visto
    if (!this.notificacionCookies) {
      this.ToggleCookies = true
    }
  },
  watch: {
    async $route (to, from) {
      // Esconder todos los elementos del footer
      let elements = document.getElementsByClassName("category-options")
      for (let i = 0; i < elements.length; i++) {
        elements[i].className = 'category-options'
      }
      
      await this.$nextTick()
      // Ajustar el padding del contenido para que no se superponga con el footer
      document.getElementById("content-wrap").style.paddingBottom = ((document.getElementById("footer").offsetHeight) + 150) + 'px'
    }
  },
  methods: {
    async showCategory (k) {

      // Si la resolucion es mayor a 1000px, no se ejecuta la funcion
      if (!this.isMobile) {
        return
      }

      let elements = document.getElementsByClassName("category-options")
      elements[k].classList.toggle("active")
      for (let i = 0; i < elements.length; i++) {
        if (i != k) {
          elements[i].className = "category-options"
        }
      }

      await this.$nextTick()
      document.getElementById("content-wrap").style.paddingBottom = ((document.getElementById("footer").offsetHeight) + 90) + 'px'
      
      // Cambiar el icono de la categoria abierta o cerrada
      switch (k) {
        case 0: 
          if (this.isOpen1) {
            this.isOpen1 = false
            this.isOpen2 = false
          } else {
            this.isOpen1 = true
            this.isOpen2 = false
          }
          break

        case 1:
          if (this.isOpen2) {
            this.isOpen2 = false
            this.isOpen1 = false
          } else {
            this.isOpen2 = true
            this.isOpen1 = false
          }
          break 
      }
    },
    cerrarCookies () {
      localStorage.setItem('notificacionCookies', true)
      this.ToggleCookies = false
    },

    // Funcion para compartir la pagina en redes sociales
    shareApp() {
      if (navigator.share) {
        if (this.language.includes('es')) {
          navigator.share({
            title: 'Español Básico',
            text: '¡Echa un vistazo a esta increíble aplicación web para aprender español!',
            url: 'https://spanish-prueba.web.app'
          })
          .then(() => console.log('Compartido con éxito'))
          .catch((error) => console.error('Error al compartir:', error))
        } else {
          navigator.share({
            title: 'Elementary Spanish',
            text: 'Check out this amazing web app to learn Spanish!',
            url: 'https://spanish-prueba.web.app'
          })
          .then(() => console.log('Compartido con éxito'))
          .catch((error) => console.error('Error al compartir:', error))
        }
      } else {
        console.log('La función de compartir no está disponible en este navegador.')
      }
    }
  }
}
</script>

<style src="@/assets/css/app.css"></style>
